<template>
    <div class="upload">
        <el-upload
            class="avatar-uploader"
            :action="uploadSetting.uploadurl"
            :accept="imgRule.accept"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleAvatarChange"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" :class="[imgRule.cls]"></i>
            <div class="el-upload__text" v-if="!imageUrl">{{tips}}</div>
            <div class="loading" v-if="loading">
                <svg viewBox="25 25 50 50" class="circular" >
                    <circle cx="50" cy="50" r="20" fill="none" class="path" ></circle>
                </svg>
            </div>
        </el-upload>
    </div>
</template>

<script>
import {getUploadParam, qiniuFormUpload} from 'api/api'
import {mapActions} from 'vuex'
export default {
    name: 'upload',
    data() {
        return {
            imageUrl: '',
            loading: false,
            uploadSetting: {
                localvurl: '', // 本地访问图片地址
                uploadauth: '', // 授权信息
                uploadfilekey: '', // 文件保存名字
                uploadurl: '' // 上传文件地址
            },
            fileOtherInfo: {
                type: 'add',
                keyid: '',
                vsource: 1, // 1自己上传 2素材 3系统默认资源
                furl: ''
            }
            // uploadType: {
            //     catecode: '', // 92:鲸内容素材-视频, 93:鲸内容素材-图片, 94:鲸内容-报告附件, 95:鲸内容-其他图片, 96:鲸内容-编辑器图片
            //     datatype: '' // IMAGE:图片; VIDEO:视频; FILE:普通文件
            // }
        }
    },
    props: ['imgRule', 'uploadType', 'tips'],
    mounted() {
    },
    methods: {
        initUploadParam() {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                },
                error: () => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        handleAvatarChange(file) {
            if (this.uploadSetting.uploadauth) {
                this.uploadFile(file)
            } else {
                this._getUploadParam(file)
            }
        },
        // 获取上传参数
        _getUploadParam (file) {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadFile(file)
                },
                error: () => {
                    this.setLoading(false)
                    this.$message.error('获取参数错误')
                }
            })
        },
        // 开始上传
        uploadFile(file) {
            let flag = this.beforeAvatarUpload(file.raw)
            if (flag) {
                let formData = new FormData()
                formData.append('file', file.raw)
                formData.append('key', this.uploadSetting.uploadfilekey)
                formData.append('token', this.uploadSetting.uploadauth)
                this.loading = true
                qiniuFormUpload({
                    url: this.uploadSetting.uploadurl,
                    data: formData,
                    success: (data) => {
                        this.loading = false
                        this.imageUrl = URL.createObjectURL(file.raw)
                        this.$emit('setImage', Object.assign({}, data, this.fileOtherInfo))
                    },
                    error: () => {
                        this.loading = false
                        this.$message.error('上传失败，请重新上传')
                    }
                })
            }
        },
        setImage(url) {
            this.imageUrl = url
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw)
            this.loading = false
            this.$emit('setImage', this.imageUrl)
        },
        beforeAvatarUpload(file) {
            this.loading = true
            // 验证格式
            let acceptType = this.imgRule.accept.split(',')
            let isJPG = false
            if (!acceptType.length) {
                isJPG = true
            } else {
                acceptType.forEach(item => {
                    if (file.type === item) {
                        isJPG = true
                        return false
                    }
                })
            }
            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG 格式!')
                this.loading = false
            }
            const isLt2M = file.size / 1024 / 1024 < this.imgRule.size
            // 验证大小
            if (!isLt2M) {
                this.$message.error(`上传图片大小不能超过 ${this.imgRule.size}MB!`)
                this.loading = false
            }
            // 验证长宽
            let isSize = true
            let _this = this
            if (this.imgRule.width) {
                isSize = new Promise(function(resolve, reject) {
                    let width = _this.imgRule.width
                    let height = _this.imgRule.height
                    let _URL = window.URL || window.webkitURL
                    let img = new Image()
                    img.onload = function() {
                        let valid = img.width >= width && img.height >= height
                        valid ? resolve() : reject()
                    }
                    img.src = _URL.createObjectURL(file)
                }).then(() => {
                    return file
                }, () => {
                    this.loading = false
                    return Promise.reject(this.$message.error('上传的icon必须是等于或大于100*100!'))
                })
            }
            return isJPG && isLt2M && isSize
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    // @import "~common/scss/variable";
    // @import "~common/scss/mixin";
    .upload {
        // @include flexBox('');
        .avatar-uploader{
            .el-upload {
                border: 1px dashed #DCDFE6;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width: 100%;
                height: 100%;
                @mixin flexBox($horizontal){
                    @if ($horizontal == '') {
                        $horizontal: flex-start
                    }
                    display: flex;
                    align-items: center;
                    justify-content: $horizontal;
                }
                background: #FAFAFA;
                &:hover{
                    border-color: #409EFF;
                }
            }
        }
        .avatar-uploader-icon {
            width: 40px;
            height: 40px;
            font-size: 40px;
            color: #909399;
            text-align: center;
        }
        .avatar {
            width: 100%;
            height: 100%;
            display: block;
        }
        .loading{
            background: rgba(0, 0, 0, 0.2);
            position: absolute;
            height: 100%;
            width: 100%;
            // @include flexBox(center);
            @mixin flexBox($horizontal){
                @if ($horizontal == '') {
                    $horizontal: flex-start
                }
                display: flex;
                align-items: center;
                justify-content: $horizontal;
            }

            .circular {
                height: 42px;
                width: 42px;
                animation: loading-rotate 2s linear infinite;
            }
            .path {
                animation: loading-dash 1.5s ease-in-out infinite;
                stroke-dasharray: 90, 150;
                stroke-dashoffset: 0;
                stroke-width: 2;
                stroke: #409eff;
                stroke-linecap: round;
            }
        }
    }
</style>
